import React, { useState, useEffect, useContext } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./blog.css";
import { StoreContext } from "../../../store/Provider";
import axios from "axios";
import moment from "moment";
import { CircularProgress } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import MenuIcon from "@material-ui/icons/Menu";
import Skeleton from "@material-ui/lab/Skeleton";
import BannerBlog from "./BannerBlog";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../common/Layout/MainLayout";
import routeConstant from "../../../route/compoent/routeConstant";

const Blogs = (props) => {
  // console.log("Build Date 11/05/23");
  const context = useContext(StoreContext);
  const [blogsData, setBlogsData] = useState([]);
  // const history = useHistory()
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  useEffect(() => {
    setBlogsData(context.blogsData);
  }, [context.blogsData]);

  useEffect(() => {
    if (!context.blogsLoaded) {
      context.blogsData.forEach((value, index, i) => {
        getBlogsFrmAPI(value.endPoint, index, 1);
      });
    }
  }, []);

  function getBlogsFrmAPI(endPoint, index, count) {
    const hostURL = `https://www.morethanshipping.com/wp-json/wp/v2/posts?_embed&page=${count}&categories=`;
    axios
      .get(hostURL + endPoint)
      .then((results) => {
        if (count == 1) {
          let newArray = [...context.blogsData];
          newArray[index].loading = false;
          newArray[index].post = results.data;
          context.setBlogsData(newArray);
          context.setBlogsLoaded(true);
        } else {
          let newArray = [...context.blogsData];
          let array = newArray[index].post;
          newArray[index].post = [...array, ...results.data];
          newArray[index].pageCount = count;
          newArray[index].loadMore = false;
          // setLoadMore(false)
          context.setBlogsData(newArray);
        }
      })
      .catch((err) => {
        if (count === 1) {
          context.setBlogsData([]);
          context.setBlogsLoaded(false);
          console.log(err);
          setOpen(true);
          setSeverity("error");
          setAlertText("Something went wrong!");
        }
      });
  }

  const onLoadMore = (data, index) => {
    console.log({ data });
    if (!data.loading) {
      let array = [...context.blogsData];
      array[index].loadMore = true;
      // setLoadMore(true)
      context.setBlogsData(array);
      // console.log(index)
      const count = data.pageCount + 1;
      getBlogsFrmAPI(data.endPoint, index, count);
    }
  };

  const BlogsCard = (props) => {
    const firstvariable = 'content="https:';
    const secondvariable = ".jpg";
    const thirdVarialbe = ".png";
    let yostHead = props.blogs.yoast_head ?? "";
    let title = props.blogs.title.rendered ?? "";
    title = title.replace("&#8217;", "'");
    const imagePath = yostHead.match(
      new RegExp(firstvariable + "(.*)" + secondvariable)
    ) ??
      yostHead.match(new RegExp(firstvariable + "(.*)" + thirdVarialbe)) ?? [
        "https://www.morethanshipping.com/wp-content/uploads/2019/06/supply-chain-global.jpg",
      ];
    let uri = imagePath[0].replace('content="', "");

    return (
      <div
        onClick={() => {
          context.setBlogsDetail({
            image: uri,
            detail: props.blogs.content.rendered,
            title: title,
          });
          navigate(routeConstant.BLOGS_DETAILS);
        }}
        className="blogCardBody"
        style={{ backgroundImage: `url(${uri})`, backgroundSize: "cover" }}
      >
        {/* <img className="cardBgImage" src="/mtsomsmerge/Assets/Images/cardBg.svg" alt="card bg Image" /> */}
        <div className="datewithTitle">
          <div className="blogDate">
            <span>{moment(props.blogs.date).format("MM/DD/YYYY")}</span>
          </div>
          <div className="cardTitle">
            <p title={title}>{title}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="blogComponent">
      {/* {!context.isUserLogin ? (
          <div className="blogHeader mb-3">
            <MenuIcon
              className={
                context.closeSidebar
                  ? "pointer toggleSidebar flip"
                  : "pointer toggleSidebar"
              }
              onClick={() => {
                //   context.setCloseSidebar(!context.closeSidebar);
                context.setSidebarOpen((prev) => !prev);
              }}
            />
            <h6>More Than Shipping</h6>
          </div>
        ) : null} */}
      <div className="blogBody">
        <div className="blogCarouselBody">
          <BannerBlog />
        </div>
        <div className="blogBodyCarouselDown">
          {blogsData.map((element, index) => {
            return (
              <div key={index} className="blogCardwithTitle">
                <h6 className="blogTitle">{element.title}</h6>
                <div className="CardCarouselContainer">
                  <Carousel
                    arrows
                    centerMode
                    slidesToSlide={2}
                    afterChange={(previousSlide, _ref) => {
                      console.log(_ref.currentSlide, _ref, previousSlide);
                      const end = _ref.currentSlide + _ref.slidesToShow;
                      if (end === element.post.length) {
                        onLoadMore(element, index);
                        console.log({ end });
                      }
                    }}
                    // autoPlaySpeed={1000}
                    containerClass="carousel-container"
                    swipeable={false}
                    draggable={false}
                    focusOnSelect={true}
                    keyBoardControl={false}
                    responsive={responsive}
                    showDots={false}
                    sliderClass=""
                  >
                    {element.post.map((item) => {
                      if (element.loading) {
                        return (
                          <div
                            className="loadingClass skeletonLoading"
                            style={{ height: "10rem" }}
                          >
                            {/* <CircularProgress size="1.5rem" /> */}
                            <Skeleton
                              variant="rect"
                              width="100%"
                              height="75%"
                            />
                            <Skeleton
                              animation="wave"
                              variant="rect"
                              width="100%"
                              height="25%"
                            />
                          </div>
                        );
                      }

                      return <BlogsCard blogs={item} key={item.id} />;
                    })}
                  </Carousel>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
    </div>
  );
};

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
    slidesToSlide: 2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

export default Blogs;
